import React from 'react';
import { Field } from 'redux-form';
import Button from '@sizeid/commons/components/Button';
import { TERMS_INDEX, PRIVACY_INDEX } from '@sizeid/shared/constants/routes';

import Form from 'components/forms/Form';
import FormField, { FormFieldSet } from 'components/forms/FormField';
import P from 'components/typo/P';
import { isSubmitDisabled } from 'utils/forms';

import SignFormsContainer from '../styled/SignFormsContainer';

import { SignUpFormProps } from './types';

const SignUpForm: React.FC<Record<string, unknown>> = _props => {
  // Do not ever again use redux form
  const props = _props as SignUpFormProps;
  return (
    <Form id={props.id} onSubmit={props.handleSubmit}>
      <>
        <SignFormsContainer>
          <FormFieldSet>
            <Field
              name="email"
              type="email"
              placeholder={props.t('signUpForm.email')}
              component={FormField}
            />
            <Field
              name="password"
              type="password"
              placeholder={props.t('signUpForm.password')}
              component={FormField}
            />
          </FormFieldSet>
        </SignFormsContainer>
        <P centered>
          <>
            {props.t('signUpForm.terms.conditions.text')}{' '}
            <a href={TERMS_INDEX.route} target="_blank" rel="noreferrer">
              {props.t('signUpForm.terms.conditions.link')}
            </a>
            <br />
            {props.t('signUpForm.terms.privacy.text')}{' '}
            <a href={PRIVACY_INDEX.route} target="_blank" rel="noreferrer">
              {props.t('signUpForm.terms.privacy.link')}
            </a>
          </>
        </P>
        <SignFormsContainer>
          <Button
            type="submit"
            disabled={isSubmitDisabled(props)}
            submitting={props.submitting}
          >
            {props.t('signUpForm.submit')}
          </Button>
        </SignFormsContainer>
      </>
    </Form>
  );
};

export default SignUpForm;
